import React from "react"
import styled from "styled-components/macro"

export const SVG_Cover_PC_L = (): JSX.Element => {
  return (
    <S_SVG_Cover_PC_L>
      <svg
        width="994"
        height="859"
        viewBox="0 0 994 859"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 0H993.5L836 858.5L0 850V0Z"
          fill="url(#paint0_linear_299_5103)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_299_5103"
            x1="152.5"
            y1="579.5"
            x2="839.143"
            y2="719.746"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2B3474" />
            <stop offset="1" stopColor="#2B3474" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </S_SVG_Cover_PC_L>
  )
}

export const S_SVG_Cover_PC_L = styled.div``
